<script lang="ts" setup>
const {
  modelValue,
  confirm = "OK",
  deny = "Cancel",
} = defineProps<{
  modelValue: boolean;
  confirm?: string;
  deny?: string;
}>();

const emit = defineEmits(["update:modelValue", "confirm", "deny"]);

const updateValue = (value: boolean) => {
  emit("update:modelValue", value);
};

const onConfirm = (value: boolean) => {
  emit("confirm", value);
};

const onDeny = (value: boolean) => {
  emit("deny", value);
};
</script>

<template>
  <ModalWindow
    :model-value="modelValue"
    :close-button="false"
    @update:model-value="updateValue"
  >
    <BaseButtonGroup>
      <BaseButton theme="overlay" @click="onConfirm">{{ confirm }}</BaseButton>
      <BaseButton theme="overlay" variant="ghost" @click="onDeny">{{
        deny
      }}</BaseButton>
    </BaseButtonGroup>
  </ModalWindow>
</template>

<style lang="scss" scoped></style>
